<template>
  <div >
     <center>
      <v-img height="100%" :src="require('@/assets/Cover_Line_Pansook.jpg')"></v-img>
      <v-container fluid>
      <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-row dense>
        <v-col style="padding-right: 8px;padding-left: 8px;">

            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
            <v-card-text>
                <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                <span class="text-h6 font-weight-light">กิจกรรม</span>
                </v-card>
                <v-row>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/punsukText.png')" @click="GoActivityPage()"></v-img>
                </v-col>
                <v-col cols="4" sm="4"></v-col>
                <v-col cols="4" sm="4"></v-col>
                </v-row>
                                  <!-- <small>
                  <v-alert class="text-left" border="right" colored-border elevation="20"
                        close-text="Close Alert"
      dismissible
                  >
                    ขณะนี้มีการจัดกิจกรรม<b>วี กรุ๊ป ปันสุข</b> เพื่อเป็นไปตามนโยบายการปรับปรุงข้อมูลและเตรียมความพร้อมโครงการ <br> จึงขอความร่วมมือให้ ท่านปรับปรุงข้อมูลดังนี้ <b>ข้อมูลส่วนตัว ครอบครัว และที่อยู่อาศัย</b> ให้ถูกต้องและสมบูรณ์เพื่อนำไปใช้ภายใต้โครงการในเครือ บริษัท วี กรุ๊ป ฮอนด้าคาร์ส์ จำกัด เท่านั้น
<br>โดยจะขอความความร่วมมือปรับปรุงข้อมูลตั้งแต่วันที่ 2 มิถุนายน ถึง 4 มิถุนายน 2565
                </v-alert>
                 </small> -->
              <v-card
                  class="mx-auto ma-5"
                  color="#1B447C"
                  dark
                  max-width="400"
                >
                <span class="text-h6 font-weight-light"> ข้อมูลส่วนตัว </span>
                </v-card>

                <v-row>
                <v-col cols="12">

                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/infoImg.png')" @click="GoInfomation()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/familyImg.png')" @click="GoFamily()"></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img height="100%" :src="require('@/assets/addressImg.png')" @click="GoUpdateAddress()"></v-img>
                </v-col>
                <v-col cols="4" sm="4"></v-col>
                </v-row>
                <br>
                <br>
                <!-- <v-row
                  align="center"
                  justify="space-around"
                >
                  <v-btn
                    depressed
                    color="primary"
                    @click="GoInfomation()"
                  >
                    ข้อมูลส่วนตัว
                  </v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    @click="GoFamily()"
                  >
                    ข้อมูลครอบครัว
                  </v-btn>
                  <v-btn
                    depressed
                    color="primary"
                    @click="GoUpdateAddress()"
                  >
                    ข้อมูลที่อยู่
                  </v-btn>
                </v-row> -->
            </v-card-text>

        </v-col>
      </v-row>
    </v-container>
     </center>
  </div>
</template>
<script>
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Event',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      dataReady: true,
      imageHeadHRM: '',
      imageUrlBack: '',
      imageUrlActivity: '',
      imageUrlPersonalInfo: '',
      imageUrlFamilyInfo: '',
      imageUrlAddressInfo: '',
      imageUrlComingSoon: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.profile.empImageUrl = this.profile.empImageUrl
    // this.imageHeadHRM = require('@/assets/Cover_Line_Pansook.jpg')
    // this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    // this.imageUrlActivity = require('@/assets/punsukText.png')
    // this.imageUrlPersonalInfo = require('@/assets/infoImg.png')
    // this.imageUrlFamilyInfo = require('@/assets/familyImg.png')
    // this.imageUrlAddressInfo = require('@/assets/addressImg.png')
    // this.imageUrlComingSoon = require('@/assets/Icon/ComingSoon.jpg')
    this.dataReady = false
    // this.getDataByFamily()
  },
  methods: {

    async getDataByFamily () {
      this.dataFamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/event_punsuk/getDataFamily?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
    },
    Home () {
      this.$router.push('/Liff/Home')
    },
    GoActivityPage () {
      this.$router.push('/Liff/RegisterEvent')
    },
    GoFamily () {
      this.$router.push('/Liff/EmpFamily')
    },
    GoInfomation () {
      this.$router.push('/Liff/EmpInfomation')
    },
    GoUpdateAddress () {
      this.$router.push('/Liff/EmpAddress')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/HomeEvent.vue